export const ADS_REVIEWS_STARTED = 'ADS_REVIEWS_STARTED';
export const ADS_REVIEWS = 'ADS_REVIEWS';
export const ADS_REViEWS_ENDED = 'ADS_REViEWS_ENDED';
export const ADD_ADS_REVIEW_STARTED = 'ADD_ADS_REVIEW_STARTED';
export const ADD_ADS_REVIEW = 'ADD_ADS_REVIEW_STARTED';
export const ADD_ADS_REVIEW_ENDED = 'ADD_ADS_REVIEW_ENDED';
export const UPDATE_ADS_REVIEW_STARTED = 'UPDATE_ADS_REVIEW_STARTED';
export const UPDATE_ADS_REVIEW = 'UPDATE_ADS_REVIEW';
export const UPDATE_ADS_REVIEW_ENDED = 'UPDATE_ADS_REVIEW_ENDED';
